import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import { AGENDA_CONSTANTS } from "../../constants/DoctorProfileConstants";
import { CalendarEventModel } from "../../models/CalendarEventModel";
import { MODAL_MESSAGES } from "./constants/EventInfoModalConstants";

Vue.use(Vuetify);
@Component({
  name: "EventInfoModal"
})
export default class EventInfoModal extends Vue {
  @Prop({ default: false }) dialog!: boolean;
  @Prop() data!: CalendarEventModel;

  dataResp: CalendarEventModel = new CalendarEventModel();
  messages = MODAL_MESSAGES;
  cardClass = STYLE_CLASSES.CARD;
  buttonFlags = true;

  @Watch("dialog")
  update() {
    const listOfPossibleStates = [
      AGENDA_CONSTANTS.AVAILABLE,
      AGENDA_CONSTANTS.BLOCKED
    ];
    this.dataResp = { ...this.data };
    if (
      listOfPossibleStates.includes(
        (this.dataResp as CalendarEventModel).patient.name
      )
    ) {
      this.buttonFlags = false;
    } else {
      this.buttonFlags = true;
    }
  }

  close() {
    this.$emit("close");
  }

  openService() {
    this.$emit("openService", this.data);
  }

  openPatientMedicalHistory() {
    this.$emit("openMedicalHistory", this.data.patient.id);
  }
}
